import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '11.8049 3.9849'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M22.1899 1.16992C22.1899 1.16992 18.7199 2.38992 12.0099 2.38992C5.29992 2.38992 1.41992 1.16992 1.41992 1.16992C1.41992 1.16992 5.01993 6.79993 11.7999 6.79993C18.5799 6.79993 22.1899 1.16992 22.1899 1.16992Z"
          fill="white"
          stroke={outline}
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
  )
}
